export const tagColors = [
  { background: '#EFE5FD', color: '#6002EE' },
  { background: '#E8F5E9', color: '#008B00' },
  { background: '#FFF2DF', color: '#EE6002' },
  { background: '#E3F2FD', color: '#1565C0' },
  { background: '#E0F2F1', color: '#00695C' },
  { background: '#FFF9C4', color: '#FFA500' },
  { background: '#EFEBE9', color: '#5D4037' },
  { background: '#F9FAFB', color: '#344054' },
  { background: '#FFEEE8', color: '#E64A19' },
  { background: '#FFE9FC', color: '#B622B7' },
  { background: '#C5F8FF', color: '#00719F' },
  { background: '#EDEEFF', color: '#5258E4' },
];

export const renderColor = (hexColor) => {
  if (!hexColor) return { background: '#F1F5F9', color: '#64748B' };
  const match = tagColors.find(
    (tc) => tc.color === hexColor || tc.background === hexColor
  );
  if (match) return match;
  return { background: `${hexColor}20`, color: hexColor };
};
